/* Chat — browser client for the `chat` Supabase Edge Function.

   The widget talks ONLY to our Edge Function, never to Groq/Gemini directly:
   the LLM keys live server-side as Supabase secrets. Same project and same
   no-key call as lib/sendForm.ts — the function is deployed with
   --no-verify-jwt and guards itself with CORS plus a Postgres rate limit. */

const CHAT_ENDPOINT = "https://ayjgfoeevktywpkqyspm.supabase.co/functions/v1/chat";

export interface ChatTurn {
  role: "user" | "assistant";
  content: string;
}

export interface ChatResult {
  text: string;
  navigate: { page: string; section?: string } | null;
  model?: "groq" | "gemini";
}

/** Send the conversation to the Edge Function and get the assistant reply.
    Throws on network / non-2xx so the widget can show a friendly fallback.
    `page` is the current pathname, counted in the daily chat stats
    (supabase/migrations/*_chat_stats.sql); it never reaches the model. */
export async function sendChat(
  locale: string,
  messages: ChatTurn[],
  page?: string,
  signal?: AbortSignal,
): Promise<ChatResult> {
  const res = await fetch(CHAT_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ locale, messages, page }),
    signal,
  });

  if (!res.ok) throw new Error(`chat-${res.status}`);

  const data = (await res.json()) as ChatResult;
  return {
    text: data.text ?? "",
    navigate: data.navigate ?? null,
    model: data.model,
  };
}
